import React from 'react';
import { Modal } from '../../components';

export const TagQtyChangeWarningModal = (props) => {
    const { show, onClose } = props;

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="p-4 min-w-min ml-4 mr-4 mt-2">
                <div className="mt-2 mb-2 px-2">
                    {
                        'Tag quantity changed but some configured products quantity'
                    }
                </div>
                <div className="mt-2 mb-2 px-2">
                    {'maybe incorrect due to some update error'}
                </div>
                <div className="px-4 py-3 sm:flex sm:px-6 jsutify-end">
                    <button
                        onClick={onClose}
                        type="button"
                        className="swegon-like-button contained !px-4"
                    >
                        OK
                    </button>
                </div>
            </div>
        </Modal>
    );
};
